import { render, staticRenderFns } from "./userBalanceList.vue?vue&type=template&id=4363541b&scoped=true"
import script from "./userBalanceList.vue?vue&type=script&lang=js"
export * from "./userBalanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363541b",
  null
  
)

export default component.exports